import { Grid } from '@mui/material';
import { EmailField, SimpleShowLayout, TextField } from 'react-admin';
import { PhoneNumberArrayField } from 'src/lib';
import { AccountHolder } from 'src/models';

import { DisclosureDetails } from '../Accounts/AccountHolder/DisclosureDetails';

interface OfferOrderAccountHolderProps {
  record: AccountHolder;
}

export const OfferOrderAccountHolder = ({ record }: OfferOrderAccountHolderProps) => {
  return (
    <Grid container direction='row'>
      <Grid item md={12}>
        <Grid container>
          <Grid item md={3}>
            <SimpleShowLayout>
              <TextField record={record} source='firstName' label='First Name' />
            </SimpleShowLayout>
          </Grid>
          <Grid item md={1}>
            <SimpleShowLayout>
              <TextField record={record} source='middleName' label='Middle Name' />
            </SimpleShowLayout>
          </Grid>
          <Grid item md={2}>
            <SimpleShowLayout>
              <TextField record={record} source='lastName' label='Last name' />
            </SimpleShowLayout>
          </Grid>
          <Grid item md={1}>
            <SimpleShowLayout>
              <TextField record={record} source='suffix' label='Suffix' />
            </SimpleShowLayout>
          </Grid>
        </Grid>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <EmailField record={record} source='email' label='Email' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <PhoneNumberArrayField record={record.phones} />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField record={record} source='financialInformation.employmentStatus.label' label='Employment Status' />
        </SimpleShowLayout>
      </Grid>
      <DisclosureDetails record={record} />
    </Grid>
  );
};
